module.exports = __webpack_public_path__ + "static/media/ArrowBottomWhite.d4bbb280.svg";